export default {
  path: "/payment/:id/:shareToken?",
  name: "request_payment",
  component: () => import("@/views/request_payment/RequestPaymentBase.vue"),
  children: [
    {
      path: "start",
      name: "request_payment_start",
      component: () => import("@/views/request_payment/Start.vue")
    },
    {
      path: "income",
      name: "request_payment_income",
      component: () => import("@/views/apply/Income.vue")
    },
    {
      path: "pay",
      name: "request_payment_pay",
      component: () => import("@/views/request_payment/Pay.vue")
    },
    {
      path: "complete",
      name: "request_payment_complete",
      component: () => import("@/views/request_payment/Complete.vue")
    }
  ]
}
